'use client'

import { GeolocationContext } from '@components/hooks/GeolocationProvider/index.client'
import getTrialLocationsNearLatLng, {
  type TrialLocationInfo,
} from '@lib/api/patients/trialLocations/getTrialLocationsNearLatLng'
import calculateDistance from '@lib/utilities/calculateDistance'
import pluralize from '@lib/utilities/text/pluralize'
import { type ClinicalTrialForListingPage } from '@modules/trials/helpers/fragments/clinicalTrialListingFragment'
import { prettyDistanceShort } from '@modules/trials/helpers/getTrialAttributes'
import { locationToPoint } from '@modules/trials/helpers/parseLocationsFromTrial/parseTruncatedLocationsFromTrial'
import { useContext, useEffect, useState } from 'react'

export const TrialLocationText = ({
  trial,
}: {
  trial: ClinicalTrialForListingPage
}) => {
  const userLocation = useContext(GeolocationContext)
  const [trialLocationInfo, setTrialLocationInfo] =
    useState<TrialLocationInfo>()
  useEffect(() => {
    if (
      userLocation.latitude &&
      userLocation.longitude &&
      !trialLocationInfo &&
      trial.slug
    ) {
      getTrialLocationsNearLatLng({
        latlng: {
          latitude: userLocation.latitude,
          longitude: userLocation.longitude,
        },
        slug: trial.slug,
      }).then((locationInfo) => setTrialLocationInfo(locationInfo))
    }
  }, [userLocation])

  const nearestLocation = trialLocationInfo?.nearestTrialLocations[0]
  const otherLocationsCount = trial.trialLocations.length - 1
  if (!nearestLocation) {
    return (
      <div className='text-base text-neutral500 blur-sm'>
        <div className='md:inline'>Recruiting in Palo Alto (17 mi)</div>
        {otherLocationsCount > 0 && (
          <div className='md:ml-1 md:inline'>
            +
            {pluralize('other location', otherLocationsCount, {
              includeCount: true,
            })}
          </div>
        )}
      </div>
    )
  }

  const distance = calculateDistance(
    locationToPoint(nearestLocation),
    userLocation,
  )

  return (
    <div className='text-base text-neutral500'>
      <div className='md:inline'>
        Recruiting in {nearestLocation.city} {prettyDistanceShort(distance)}
      </div>
      {otherLocationsCount > 0 && (
        <div className='md:ml-1 md:inline'>
          +
          {pluralize('other location', otherLocationsCount, {
            includeCount: true,
          })}
        </div>
      )}
    </div>
  )
}
